var map = {
	"./abnormality.svg": 64579,
	"./access-statistics.svg": 4805,
	"./admin-log.svg": 38811,
	"./admin.svg": 57654,
	"./ai.svg": 22415,
	"./application.svg": 32041,
	"./atom.svg": 85894,
	"./backend-errors.svg": 4121,
	"./banner.svg": 36231,
	"./bell.svg": 98646,
	"./calendar.svg": 43971,
	"./cdn.svg": 36714,
	"./cms-block.svg": 23892,
	"./cms-page.svg": 52432,
	"./cms-www.svg": 24790,
	"./comment.svg": 80380,
	"./config-file.svg": 73638,
	"./contact.svg": 27623,
	"./corpus.svg": 3925,
	"./decoration.svg": 68607,
	"./document-mng.svg": 59649,
	"./document.svg": 58058,
	"./email.svg": 65891,
	"./exception-handle.svg": 65063,
	"./exception.svg": 75348,
	"./expand.svg": 59185,
	"./feedback.svg": 22080,
	"./front.svg": 91750,
	"./frontend-errors.svg": 69771,
	"./fsf.svg": 52826,
	"./func.svg": 36411,
	"./gift-manage.svg": 90509,
	"./gift.svg": 94831,
	"./global.svg": 95344,
	"./goods.svg": 58633,
	"./goods_type.svg": 58772,
	"./group.svg": 76350,
	"./history.svg": 72175,
	"./i18n.svg": 63385,
	"./index.svg": 17179,
	"./intelligence-chat.svg": 13051,
	"./intelligence-history.svg": 39483,
	"./intelligence-keywords.svg": 1777,
	"./intelligence-oss.svg": 30682,
	"./intelligence-rag.svg": 11565,
	"./intelligence-stat.svg": 29327,
	"./intelligence-vocabulary.svg": 54053,
	"./intelligence.svg": 12040,
	"./log.svg": 98169,
	"./log2.svg": 99369,
	"./lucky-manage.svg": 65989,
	"./lucky.svg": 20615,
	"./mall.svg": 79779,
	"./manage.svg": 48220,
	"./menu.svg": 56412,
	"./message.svg": 4622,
	"./model.svg": 94504,
	"./node.svg": 28121,
	"./notice.svg": 41057,
	"./open-folder.svg": 96442,
	"./oss.svg": 69654,
	"./permission.svg": 82556,
	"./phone-msg.svg": 48911,
	"./phone-tpl.svg": 71452,
	"./platform.svg": 32436,
	"./pm.svg": 78020,
	"./private.svg": 99730,
	"./product.svg": 92958,
	"./project.svg": 38296,
	"./promotion.svg": 45912,
	"./purchase-records.svg": 74849,
	"./read.svg": 83917,
	"./redis.svg": 82250,
	"./role.svg": 88189,
	"./server.svg": 5096,
	"./setting.svg": 46587,
	"./shipping.svg": 33231,
	"./spider.svg": 84930,
	"./stat.svg": 34587,
	"./support.svg": 64722,
	"./system.svg": 13070,
	"./tag.svg": 64051,
	"./talent.svg": 61607,
	"./template-email.svg": 9940,
	"./template-message.svg": 62233,
	"./template-phone.svg": 6168,
	"./template-wxmsg.svg": 80796,
	"./template.svg": 9907,
	"./unread.svg": 85808,
	"./upload-log.svg": 54863,
	"./user-log.svg": 66077,
	"./user.svg": 65576,
	"./users.svg": 35387,
	"./wx-exception.svg": 60628,
	"./wx.svg": 9252,
	"./wxmsg.svg": 50487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80638;